var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gvl-impressum" }, [
      _c(
        "div",
        {
          staticClass: "field-item even",
          attrs: { property: "content:encoded" }
        },
        [
          _c("p", [
            _vm._v(
              "GESELLSCHAFT ZUR VERWERTUNG VON LEISTUNGSSCHUTZRECHTEN mbH (GVL)"
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Podbielskiallee 64")]),
          _vm._v(" "),
          _c("p", [_vm._v("14195 Berlin")]),
          _vm._v(" "),
          _c("p", [_vm._v("Postfach 330361")]),
          _vm._v(" "),
          _c("p", [_vm._v("14173 Berlin")]),
          _vm._v(" "),
          _c("p", [_vm._v("Telefon: 0202-2515 57305")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("E-Mail: "),
            _c(
              "a",
              {
                attrs: {
                  href: "mailto:kontakt@gvl-stipendienprogramm.de",
                  rel: "nofollow"
                }
              },
              [_vm._v("kontakt@gvl-stipendienprogramm.de")]
            ),
            _vm._v(
              " (Anfragen zum Stipendienprogramm bitte an die Hotline richten.)"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Internet: "),
            _c(
              "a",
              { attrs: { href: "https://www.gvl.de", rel: "nofollow" } },
              [_vm._v("https://www.gvl.de")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Geschäftsführer der GVL: Dr. Tilo Gerlach und Guido Evers")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Aufsichtsbehörde: Deutsches Patent- und Markenamt, Zweibrückenstr. 12, 80331 München"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Bundeskartellamt, Kaiser-Friedrich-Strasse 16, 53113 Bonn")
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Handelsregisternummer: Amtsgericht Charlottenburg, HRB 92075"
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("USt-IdNr.: DE 118 554 621")]),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Verantwortliche i.S.d. § 55 Abs. 2 RStV: Juliane Fiedler, Podbielskiallee 64, 14195 Berlin"
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "Haftungsausschluss: Die Inhalte der Webseite gvl.de werden regelmäßig gepflegt und aktualisiert. Jedoch wird keine Gewähr für die Richtigkeit, die Vollständigkeit oder die Verfügbarkeit der im Rahmen des Dienstes abrufbaren Informationen übernommen. Für externe Inhalte, auf die in der Webseite gvl.de hingewiesen wird, wird keine Verantwortung übernommen. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich."
            )
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Konzeption und Webentwicklung:")]),
          _vm._v(" "),
          _c("p", [
            _c(
              "a",
              { attrs: { href: "https://nakami.de", target: "_blank" } },
              [_vm._v("nakami lounge GmbH")]
            ),
            _vm._v(", München")
          ])
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }